module.exports = __webpack_public_path__ + "img/services.065a50fe.png";